{
  "appointment-history-page": {
    "text": {
      "in-the-past": "Dans le passé ou annulé",
      "no-appointment": "Vous n'avez pas pris de rendez-vous !",
      "upcoming": "Prochain rendez-vous"
    },
    "meta": {
      "title": "Rendez-vous",
      "description": "Liste des rendez-vous pris"
    }
  }
}
